import script from "./DiscrepanciaFuentes.vue?vue&type=script&setup=true&lang=js"
export * from "./DiscrepanciaFuentes.vue?vue&type=script&setup=true&lang=js"

import "./DiscrepanciaFuentes.vue?vue&type=style&index=0&id=95bbf350&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95bbf350"]])

export default __exports__